import { render, staticRenderFns } from "./BaseSelectCheckbox.vue?vue&type=template&id=2a23da95&"
import script from "./BaseSelectCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseSelectCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports